export function getApiBase() {
  const explicit = (process.env.REACT_APP_API_URL || '').trim();
  if (explicit) {
    return explicit.replace(/\/$/, '');
  }
  try {
    const { protocol, hostname, port } = window.location;
    if (port === '3000') {
      return `${protocol}//${hostname}:5000`;
    }
    return `${protocol}//${hostname}${port ? `:${port}` : ''}`;
  } catch (_) {
    return 'http://localhost:5000';
  }
}


